import { ContextColumnsBase } from "@mwt/web-js-telemetry";
import { useCallback } from "react";
import { createContainer, useContainer } from "unstated-next";

import {
  ContextColumns,
  updateLoggingContext,
  getBrowserLocale,
} from "@smb/web-telemetry";

import { changeLocale, initializeLocale } from "./helpers/initializeLocale";

const browserLocale = getBrowserLocale();
initializeLocale(browserLocale);
updateLoggingContext({ [ContextColumns.UserInfoLanguage]: browserLocale });

function useLocalizationContextHook() {
  const setLocale = useCallback((locale: string) => {
    changeLocale(locale);
    updateLoggingContext({ [ContextColumnsBase.UserInfoLanguage]: locale });
  }, []);

  return { setLocale };
}

const LocalizationProviderContext = createContainer(useLocalizationContextHook);
export const LocalizationProvider = LocalizationProviderContext.Provider;

export const useLocalizationContext = () =>
  useContainer(LocalizationProviderContext);
